export enum CardVariant {
  DEFAULT = "default",
  WARNING = "warning",
  SELECTED = "selected",
  DISABLED = "disabled",
}
